import { render, staticRenderFns } from "./intimateRule.vue?vue&type=template&id=49cc4531&scoped=true"
import script from "./intimateRule.vue?vue&type=script&lang=js"
export * from "./intimateRule.vue?vue&type=script&lang=js"
import style0 from "./intimateRule.vue?vue&type=style&index=0&id=49cc4531&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49cc4531",
  null
  
)

export default component.exports